module.exports = __webpack_public_path__ + "img/Crepu.39009ffd.jpg";